import confetti from "canvas-confetti";
import { toast } from "sonner";

const themeColors = () => {
  const css = getComputedStyle(document.documentElement);
  return ["--t-primary", "--t-c2", "--t-c3", "--t-c5"]
    .map((v) => css.getPropertyValue(v).trim().split(/[\s,]+/).map(Number))
    .filter((c) => c.length === 3 && c.every((n) => !Number.isNaN(n)))
    .map((c) => `#${c.map((n) => n.toString(16).padStart(2, "0")).join("")}`);
};

export const isAllDone = (list) => list.items.length > 0 && list.items.every((i) => i.done);

export const celebrateIfDone = (before, after) => {
  if (isAllDone(before) || !isAllDone(after)) return;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (!reduce) confetti({ particleCount: 70, spread: 70, startVelocity: 32, ticks: 160, origin: { y: 0.7 }, colors: themeColors(), disableForReducedMotion: true });
  toast.success(`${after.name} all done!`, { description: "Every task ticked off. Lovely work." });
};
